"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _affiliateActions = require("../actions/affiliate-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  trackingByApplicationUuid: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   application: {
    //     applicationUuid: '',
    //     type: ''
    //   }
    //   affiliate: {
    //     affiliateId: '',
    //     type: ''
    //   },
    //   eventNames: ['']
    // }
  },
  userData: {
    name: {
      firstName: '',
      lastName: ''
    },
    address: {
      street1: '',
      street2: '',
      city: '',
      state: '',
      zip: '',
      type: ''
    },
    email: '',
    dob: '',
    income: 0,
    helocReason: '',
    trackingNumber: ''
  }
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_affiliateActions.GET_APP_AFFILIATE_TRACKING, "_").concat(_httpActions.REQUEST), "".concat(_affiliateActions.GET_LENDING_TREE_BORROWER, "_").concat(_httpActions.REQUEST), "".concat(_affiliateActions.GET_AFFILIATE_PREPOP_DATA, "_").concat(_httpActions.REQUEST), "".concat(_affiliateActions.GET_AFFILIATE_OFFER_PREPOP_DATA, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread({}, state);
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_affiliateActions.GET_LENDING_TREE_BORROWER, "_").concat(_httpActions.SUCCESS), "".concat(_affiliateActions.GET_AFFILIATE_PREPOP_DATA, "_").concat(_httpActions.SUCCESS), "".concat(_affiliateActions.GET_AFFILIATE_OFFER_PREPOP_DATA, "_").concat(_httpActions.SUCCESS)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    userData: action.payload
  });
}), (0, _defineProperty2.default)(_handleActions, _affiliateActions.CLEAR_PREPOP_DATA, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    userData: initialState.userData
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_affiliateActions.GET_APP_AFFILIATE_TRACKING, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var applicationUuid = action.payload.applicationInfo.applicationUuid;
  var tracking = state.trackingByApplicationUuid[applicationUuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    trackingByApplicationUuid: (0, _defineProperty2.default)({}, applicationUuid, _objectSpread(_objectSpread({}, tracking), {}, {
      application: {
        applicationUuid: action.payload.applicationInfo.applicationUuid,
        type: action.payload.applicationInfo.type
      },
      affiliate: _objectSpread(_objectSpread({}, tracking.affiliate), {}, {
        affiliateId: action.payload.affiliate.affiliateId,
        type: action.payload.affiliate.type
      }),
      eventNames: (0, _toConsumableArray2.default)(action.payload.eventNames)
    }))
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;